import axiosInstance from '@api/axios.ts';
import { urls } from '@api/urls.ts';
import { DocumentPromptPreview } from '@app/types/document-prompt-preview';
import { DocumentPromptPreviewFormFields } from '@features/admin-document-prompt-preview/utils/form-validators.ts';

export const deleteDocumentPromptPreview = async (
  id: number
): Promise<void> => {
  const response = await axiosInstance.delete(
    urls.documentPromptPreview.byId(id)
  );

  return response.data;
};

export const updateDocumentPromptPreview = async (
  id: number,
  data: Partial<DocumentPromptPreviewFormFields>
): Promise<DocumentPromptPreview> => {
  const response = await axiosInstance.patch(
    urls.documentPromptPreview.byId(id),
    data
  );

  return response.data;
};

export const generateDocumentPromptPreview = async (
  id: number
): Promise<DocumentPromptPreview> => {
  const response = await axiosInstance.post(
    urls.documentPromptPreview.generate(id)
  );

  return response.data;
};
